export function EventDetails({ rows }) {
  const details = [
    {
      title: "RECINTO",
      items: [rows.location_event],
    },
    {
      title: "HORA DE INICIO",
      items: [rows.full_date_formatted],
    },
    {
      title: "RESTRICCIONES",
      items: [
        "No se permite el reingreso",
        "Presentar Ticket o E-Ticket obligatorio",
      ],
    },
  ]

  return (
    <div style={{ maxWidth: "64rem", margin: "0 auto" }}>
      <h2 className="text-center mb-5" style={{ fontSize: "2rem", fontWeight: "bold" }}>
        Detalles del Evento
      </h2>

      <div className="row g-4 mb-5">
        {details.map((section, idx) => (
          <div key={idx} className="col-12 col-md-6">
            <div
              style={{
                padding: "1.5rem",
                borderRadius: "0.5rem",
                backgroundColor: "rgba(28, 32, 52, 0.5)",
                border: "1px solid var(--border-color)",
                transition: "border-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.borderColor = "rgba(237, 144, 13, 0.5)")}
              onMouseLeave={(e) => (e.currentTarget.style.borderColor = "var(--border-color)")}
            >
              <h3
                style={{
                  fontSize: "1.125rem",
                  fontWeight: "bold",
                  color: "var(--primary-color)",
                  marginBottom: "1rem",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                }}
              >
                {section.title}
              </h3>
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {section.items.map((item, itemIdx) => (
                  <li
                    key={itemIdx}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "0.75rem",
                      color: "#d1d5db",
                      marginBottom: itemIdx < section.items.length - 1 ? "0.5rem" : 0,
                    }}
                  >
                    <svg
                      style={{
                        width: "1.25rem",
                        height: "1.25rem",
                        color: "var(--primary-color)",
                        flexShrink: 0,
                        marginTop: "0.125rem",
                      }}
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 10 10.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      <div
        style={{
          padding: "2rem",
          background: "linear-gradient(135deg, rgba(180, 83, 9, 0.3) 0%, rgba(159, 18, 57, 0.3) 100%)",
          borderRadius: "0.5rem",
          border: "1px solid rgba(237, 144, 13, 0.3)",
        }}
      >
        <p style={{ textAlign: "center", color: "#d1d5db", margin: 0 }}>
          <span style={{ fontWeight: 600, color: "#fef3c7" }}>Nota importante:</span> La descarga de los E-tickets
          estará disponible desde el primer día de la venta.
        </p>
      </div>
    </div>
  )
}
